import { render } from "./SysSet.vue?vue&type=template&id=c6b4fd7a&scoped=true"
import script from "./SysSet.vue?vue&type=script&lang=js"
export * from "./SysSet.vue?vue&type=script&lang=js"

import "./SysSet.vue?vue&type=style&index=0&id=c6b4fd7a&scoped=true&lang=css"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b4fd7a"]])

export default __exports__